import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/lesson'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(lesson) {
    return http.post(`${resource}`, lesson)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(lesson, uuid) {
    return http.put(`${resource}/${uuid}`, lesson)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
